import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import SmallSlidePanel from "../add_customer/SmallSlidePanel";

const LoadingModal = ({ id, isloadingModal }) => {
  const controlsFirst = useAnimation();
  const controlsSecond = useAnimation();
  const controlsThird = useAnimation();

  useEffect(() => {
    if (isloadingModal) {
      controlsFirst.start({
        y: [0, -10, 0],
        transition: {
          duration: 0.6,
          repeat: Infinity,
          repeatType: "loop",
          ease: "easeInOut",
          delay: 0,
        },
      });

      controlsSecond.start({
        y: [0, -10, 0],
        transition: {
          duration: 0.6,
          repeat: Infinity,
          repeatType: "loop",
          ease: "easeInOut",
          delay: 0.2,
        },
      });

      controlsThird.start({
        y: [0, -10, 0],
        transition: {
          duration: 0.6,
          repeat: Infinity,
          repeatType: "loop",
          ease: "easeInOut",
          delay: 0.6,
        },
      });
    } else {
      controlsFirst.stop();
      controlsSecond.stop();
      controlsThird.stop();
    }
  }, [isloadingModal, controlsFirst, controlsSecond, controlsThird]);

  return (
    <SmallSlidePanel
      isOpen={isloadingModal}
      onClose={() => {}}
      width={520}
      showCloseButton={false}
    >
      <div id={id} className="relative bg-white shadow-lg p-6 rounded-md">
        <div className="flex items-center justify-center mt-10 mb-8">
          <motion.div
            className="bg-black w-2 h-2 rounded-full mx-2"
            animate={controlsFirst}
          />
          <motion.div
            className="bg-black w-2 h-2 rounded-full mx-2"
            animate={controlsSecond}
          />
          <motion.div
            className="bg-black w-2 h-2 rounded-full mx-2"
            animate={controlsThird}
          />
        </div>

        <div className="text-center">
          <div className="mt-4 mx-auto items-center justify-center">
            <div className="text-[#000] mt-5 text-[15px] font-normal">
              <p>
                Reading the document to retrieve information. This might take a
                few seconds.
              </p>
            </div>
          </div>
        </div>
      </div>
    </SmallSlidePanel>
  );
};

export default LoadingModal;
